// extracted by mini-css-extract-plugin
export var bulletList = "styles-module__bulletList___PmUwB";